import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FuncaoService, Login, RcmsCotacao, RcmsFavorecido, RcmsItem } from 'eddydata-lib';


declare var $: any;


type VisualizacaoItem = {
  descricao?: String,
  valor_unitario?: number,
  quantidade?: number,
  rcmsItem?: RcmsItem,
  rcmsFavorecido?: RcmsFavorecido
}

type Visualizacao = {
  descricao?: String,
  itens?: VisualizacaoItem[]
}

@Component({
  selector: 'app-rcms-cotacao',
  templateUrl: './rcms-cotacao.component.html'
})
export class RcmsCotacaoComponent implements OnInit, OnChanges {


  public imaskValor = {
    mask: Number,
    scale: 5,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };


  @Input() public login: Login;
  @Input() somenteVisualizar: boolean = false;

  @Input() itens: RcmsItem[];
  @Output() itensChange: EventEmitter<RcmsItem[]> = new EventEmitter();

  @Input() favorecidos: RcmsFavorecido[];

  public favorecido: RcmsFavorecido;
  public visualizacoes: Visualizacao[] = [];

  public listTipos: any[];
  public listOpcoes: any[];

  public tipo: 'I' | 'F' = 'F';
  public opcao: 'T' | 'V' | 'P' | 'E' = 'T';


  constructor(public funcaoService: FuncaoService) {
    this.listTipos = [
      { icon: 'fa fa-user-friends', nome: 'Fornecedor', tipo: 'F' },
      { icon: 'fa fa-boxes', nome: 'Itens', tipo: 'I' }
    ];
    this.listOpcoes = [
      { nome: 'TODOS', opcao: 'T' },
      { nome: 'VITORIAS', opcao: 'V' },
      { nome: 'PERDAS', opcao: 'P' },
      { nome: 'EMPATES', opcao: 'E' }
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itens || changes.favorecidos)
      this.visulizarCotacao();
    this.carregarCotacoes();
  }

  ngOnInit(): void {
  }

  public visulizarCotacao() {
    let visualizacoes: Visualizacao[] = [];
    if (!this.itens)
      return [];
    for (let rcmsItem of this.itens) {
      if (!rcmsItem.cotacoes)
        continue;
      for (let cotacao of rcmsItem.cotacoes) {
        let visualizacao: Visualizacao = {};

        visualizacao.itens = [];
        let item: VisualizacaoItem = {};

        if (!cotacao.valor_unitario)
          continue;

        item.rcmsItem = rcmsItem;
        item.rcmsFavorecido = cotacao.rcmsFavorecido;
        item.quantidade = rcmsItem.quantidade;
        item.valor_unitario = cotacao.valor_unitario;

        if (this.tipo === 'F') {
          visualizacao.descricao = cotacao.rcmsFavorecido.favorecido.nome;
          item.descricao = `${rcmsItem.produto_unidade.produto.nome} - ${rcmsItem.produto_unidade.unidade.nome}`;
        } else {
          visualizacao.descricao = `${rcmsItem.produto_unidade.produto.nome} - ${rcmsItem.produto_unidade.unidade.nome}`;
          item.descricao = cotacao.rcmsFavorecido.favorecido.nome;
        }
        let visua = visualizacoes.find((v) => v.descricao === visualizacao.descricao);
        if (visua)
          visualizacao = visua;
        visualizacao.itens.push(item);
        if (!visua)
          visualizacoes.push(visualizacao);
      }
    }
    this.visualizacoes = visualizacoes;
  }

  public carregarCotacoes() {
    if (!this.favorecidos || this.favorecidos.length === 0 || !this.itens || this.itens.length === 0)
      return;
    this.favorecidos.forEach((favorecido) => {
      if (!favorecido.cotacoes)
        favorecido.cotacoes = [];
      this.itens.forEach((item) => {
        let cotacao = favorecido
          .cotacoes.find((c) => c.rcmsItem.produto_unidade.id === item.produto_unidade.id);
        let cotacaoItem = !item.cotacoes ? null : item.cotacoes.find((c) => c.rcmsFavorecido.favorecido.id === favorecido.favorecido.id);
        if (!cotacao && cotacaoItem) {
          cotacaoItem.rcmsItem = item;
          favorecido.cotacoes.push(cotacaoItem);
        } else if (!cotacao) {
          cotacao = new RcmsCotacao();
          cotacao.rcmsItem = item;
          cotacao.valor_unitario = 0.0;
          favorecido.cotacoes.push(cotacao);
        }
      });
    });
  }

  public confirmar() {
    if (this.favorecidos) {
      this.itens.forEach((i) => {
        i.cotacoes = [];
      });
      // this.favorecidos.forEach((f) => {
      //   if (f.cotacoes)
      //     f.cotacoes = f.cotacoes.filter((c) => c.valor_unitario);
      // });
      this.favorecidos.forEach((f) => {
        if (f.cotacoes)
          f.cotacoes.forEach((c) => {
            c.rcmsFavorecido = f;
            let item = this.itens.find((i) => i.produto_unidade.id === c.rcmsItem.produto_unidade.id);
            if (item) {
              item.cotacoes.push(c);
            }
          })
      });
      this.visulizarCotacao();
      this.fechar();
      this.itensChange.emit(this.itens);
    }
  }

  public valorMaior(item: RcmsCotacao) {
    for (let item1 of this.itens) {
      if (item.rcmsItem.produto_unidade.id === item1.produto_unidade.id)
        for (let cotacoes of item1.cotacoes) { }
    }
  }

  fechar() {
    this.favorecido = null;
    $('#dialogCotacoesCad').modal('hide');
  }

  public compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

  public visualizar() {
    this.carregarCotacoes();
    $('#dialogCotacoesCad').modal('show');
  }

  public vencedor(visualizacaoItem: VisualizacaoItem): 'V' | 'P' | 'E' {
    if (!visualizacaoItem)
      return 'P';
    for (let cotacao of visualizacaoItem.rcmsItem.cotacoes
      .sort((a, b) => a.valor_unitario - b.valor_unitario)) {
      if (cotacao.valor_unitario <= 0)
        continue;
      if (cotacao.rcmsFavorecido.favorecido.id === visualizacaoItem.rcmsFavorecido.favorecido.id)
        continue;
      if (+cotacao.valor_unitario === +visualizacaoItem.valor_unitario)
        return 'E';
      if (+cotacao.valor_unitario < +visualizacaoItem.valor_unitario)
        return 'P';
    }
    return 'V';
  }

  public somaItens(): { quantidade: number, valor_unitario: number } {
    let soma = { quantidade: 0, valor_unitario: 0 };
    if (!this.favorecidos || this.favorecidos.length === 0)
      return soma;
    for (let visualizacao of this.visualizacoes) {
      for (let item of visualizacao.itens) {
        if ((this.opcao === 'V' && this.vencedor(item) !== 'V')
          || (this.opcao === 'P' && this.vencedor(item) !== 'P')
          || (this.opcao === 'E' && this.vencedor(item) !== 'E'))
          continue;
        soma.quantidade += +item.quantidade;
        soma.valor_unitario += +item.valor_unitario;
      }
    }
    return soma;
  }

  public corOpcao() {
    return {
      'bg-info': this.opcao === 'T',
      'bg-success': this.opcao === 'V',
      'bg-danger': this.opcao === 'P',
      'bg-warning': this.opcao === 'E',
    };
  }
}